export class Constants{
    public static readonly JWT_TOKEN = 'JWT_TOKEN';
    public static readonly REFRESH_TOKEN = 'REFRESH_TOKEN';
    public static readonly USER = 'USER';
    public static readonly USER_CODE = 'USER_CODE';
    public static readonly COMPANY_NAME = 'COMPANY_NAME';
    public static readonly COMPANY_WEBSITE = 'COMPANY_WEBSITE';

    public static readonly ERROR_CODE = 400;
    public static readonly SUCCESS_CODE = 200;

    public static readonly LOGGED_IN_SUCCESS_MESSAGE = 'Logged in Successfully';

    public static readonly CHANGE_PASSWORD_SUCCESS_MESSAGE = 'Password Changed Successfully';
}